<template>
	<transition name="fade">
		<div
			class="modal"
			:class="value ? 'show' : 'hide'"
			:style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
				<div class="modal-content">
					<div class="modal-header d-flex flex-row align-items-center">
						<h5 class="modal-title">Demande de résiliation</h5>
					</div>
					<div class="modal-body">
						<div v-if="reqError" class="d-flex justify-content-center align-items-center full-available-height">
							{{ reqError }}
						</div>
						<div v-else>
							<flow-form
								v-if="value"
								ref="flowform"
								v-on:submit="submitCancellationRequest"
								v-bind:questions="questions"
								v-bind:language="language"
								v-bind:navigation="true"
							/>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							@click="closeModal"
						>
							Fermer
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>

import FlowFormFileType from '../components/FileType.vue';
import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form';

FlowForm.components.FlowFormQuestion.components.FlowFormFileType = FlowFormFileType
FlowForm.components.FlowFormQuestion.components.FlowFormLongTextType.methods.onEnterDown = () => {};
FlowForm.components.FlowFormQuestion.methods.onEnter = function($event) {
	if($event){
    	this.checkAnswer(this.emitAnswer);
	}
};

export default {
	name: "CancellationRequest",
	components: { FlowForm },
	props: {
		value: {
			default: false,
			type: Boolean,
		},
		en_id: {
			default: 0,
			type: Number,
		},
	},
  	data() {
		return {
			isLoading: false,
			reqError: null,
			language: new LanguageModel({
				ok: 'Suivant',
				continue: 'Poursuivre',
				ariaTypeAnswer: 'Saisissez votre réponse ici',
				placeholder: 'Saisissez votre réponse ici',
				thankYouText: 'Merci d’avoir répondu à ces questions. Validez votre demande pour la finaliser. Nous allons vous contacter rapidement pour y répondre.',
				successText: '', //'Votre demande a bien été envoyée et sera traitée dans les meilleurs délais. Vous pouvez fermer cette fenêtre.',
				pressEnter: 'appuyez sur entrée',
				otherPrompt: 'Autre',
				submitText: 'Envoyer la demande'
			}),
			questions: [
				new QuestionModel({
					id: "_root",
					required: true,
					multiple: false,
					helpTextShow: false,
					title: 'Pour quel motif souhaitez-vous résilier l\'abonnement Emotivi ?',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Le bénéficiaire du service est décédé',
							value: 'REASON_DECEASED'
						}),/*
						new ChoiceOption({
							label: 'Le bénéficiaire du service déménage en EHPAD ou en résidence sénior',
							value: 'REASON_MOVED'
						}),
						new ChoiceOption({
							label: 'Le bénéficiaire a du mal à utiliser le service',
							value: 'REASON_USABILITY'
						}),
						new ChoiceOption({
							label: 'Le kit Emotivi ne fonctionne pas/plus',
							value: 'REASON_MALFUNCTION'
						}),
						new ChoiceOption({
							label: 'Autre',
							value: 'REASON_OTHER'
						})*/
						new ChoiceOption({
							label: 'Vous n\'êtes pas satisfait du service',
							value: 'REASON_DISSATISFIED'
						}),
						new ChoiceOption({
							label: 'Vous n\'avez plus l\'utilité du service',
							value: 'REASON_USELESS'
						})
					],
					jump: {
						REASON_DECEASED: '_a',
						//REASON_MOVED: '_b',
						//REASON_USABILITY: '_c',
						//REASON_MALFUNCTION: '_d',
						//REASON_OTHER: '_e',
						REASON_DISSATISFIED: '_f',
						REASON_USELESS: '_g',
					}
				}),

				new QuestionModel({
					id: "_a",
					required: true,
					helpTextShow: false,
					title: '',
					tagline: 'Nous vous adressons nos sincères condoléances. Afin de traiter votre demande au plus vite nous vous remercions de nous communiquer un certificat de décès.',
					description: 'Formats autorisés : jpeg, png, pdf',
					type: FlowFormFileType.name,
					jump: () => "_submit"
				}),

				/*
				new QuestionModel({
					id: "_b",
					required: true,
					helpTextShow: false,
					title: '',
					tagline: 'Beaucoup de nos utilisateurs ont décidé de garder EMOTIVI en établissement afin de conserver ce lien familial. Si vous le souhaitez également, nous vous aidons à transférer le kit de chez vous à l\'établissement. Découvrez comment.',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Je souhaite recevoir plus d\'informations',
							value: 'CALL_ME_BACK'
						}),
						new ChoiceOption({
							label: 'Ça ne m\'intéresse pas d\'en savoir plus',
							value: 'CANCEL'
						})
					],
					jump: () => "_submit"
				}),

				new QuestionModel({
					id: "_c",
					required: true,
					helpTextShow: false,
					title: '',
					tagline: 'Pouvez-vous préciser quelles sont les difficultées rencontrées dans l\'utilisation du service ?',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Le bénéficiaire n\'est plus en mesure de décrocher lors d\'un appel',
							value: 'PICKUP'
						}),
						new ChoiceOption({
							label: `L'état de santé du bénéficiaire ne lui permet de plus de communiquer en visio`,
							value: 'COMMUNICATION'
						}),
						new ChoiceOption({
							label: `Autre`,
							value: 'OTHER'
						})
					],
					jump: {
						PICKUP: '_c_a',
						COMMUNICATION: '_c_b',
						OTHER: '_e'
					}
				}),

				new QuestionModel({
					id: "_c_a",
					required: true,
					helpTextShow: false,
					tagline: 'Savez-vous qu\'il est possible de mettre en place un décrochage automatique ? La réponse à l\'appel se fait automatiquement a l\'issue d\'un délai configurable.',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Je souhaite recevoir plus d\'informations',
							value: 'CALL_ME_BACK'
						}),
						new ChoiceOption({
							label: 'Ça ne m\'intéresse pas d\'en savoir plus',
							value: 'CANCEL'
						})
					],
					jump: () => "_submit"
				}),

				new QuestionModel({
					id: "_c_b",
					required: true,
					helpTextShow: false,
					tagline: 'EMOTIVI a été conçue pour garder le plus longtemps possible ce lien. S\'il n\'est plus possible en interaction vidéo, il peut continuer au travers de photos et messages partageant vos instants de famille qui font du bien à votre proche.',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Je souhaite recevoir plus d\'informations',
							value: 'CALL_ME_BACK'
						}),
						new ChoiceOption({
							label: 'Ça ne m\'intéresse pas d\'en savoir plus',
							value: 'CANCEL'
						})
					],
					jump: () => "_submit"
				}),

				new QuestionModel({
					id: "_d",
					required: true,
					helpTextShow: false,
					title: '',
					tagline: 'Pouvez-vous nous préciser ce qui ne fonctionne pas ?',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Vous n\'êtes pas parvenu à configurer le kit Emotivi',
							value: 'NOT_WELL_CONFIGURED'
						}),
						new ChoiceOption({
							label: 'Un message indique que la box n\'est pas connectée quand vous souhaitez appeler',
							value: 'NOT_CONNECTED'
						}),
						new ChoiceOption({
							label: 'Le bénéficiaire à recemment changé de téléviseur',
							value: 'TV_CHANGED'
						}),
						new ChoiceOption({
							label: 'Lors d\'un appel, le téléviseur du bénéficiaire reste sur le canal TV (ou ne s\'allume pas)',
							value: 'NO_SWITCH_TO_EMOTIVI'
						}),
						new ChoiceOption({
							label: 'Le téléviseur ne rebascule pas sur la chaine TV à l\'issue de l\'appel',
							value: 'NO_SWITCH_TO_TV'
						}),
						new ChoiceOption({
							label: 'Lors d\'un appel le téléviseur bascule bien sur la source HDMI mais l\'écran reste noir',
							value: 'BLACK_HDMI_SCREEN'
						}),
						new ChoiceOption({
							label: 'La qualité de l\'appel (son, image) se dégrade au bout d\'un certain temps',
							value: 'POOR_CALL_QUALITY'
						}),
						new ChoiceOption({
							label: `Autre`,
							value: 'OTHER'
						})
					],
					jump: {
						NOT_WELL_CONFIGURED: '_d_c',
						NOT_CONNECTED: '_d_c',
						TV_CHANGED: '_d_c',
						NO_SWITCH_TO_EMOTIVI: '_d_c',
						NO_SWITCH_TO_TV: '_d_c',
						BLACK_HDMI_SCREEN: '_d_c',
						POOR_CALL_QUALITY: '_d_c',
						OTHER: '_e'
					}
				}),

				new QuestionModel({
					id: "_d_b",
					required: true,
					helpTextShow: false,
					tagline: 'Pouvez-vous préciser ?',
					type: QuestionType.LongText,
					jump: () => "_d_c"
				}),

				new QuestionModel({
					id: "_d_c",
					required: true,
					helpTextShow: false,
					tagline: 'Souhaitez-vous que l\'on échange afin de voir avec vous ce qui serait possible pour garder ce lien malgré ces diffcultés ?',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Oui',
							value: 'CALL_ME_BACK'
						}),
						new ChoiceOption({
							label: 'Non',
							value: 'CANCEL'
						})
					],
					jump: () => "_submit"
				}),

				new QuestionModel({
					id: "_e",
					required: true,
					helpTextShow: false,
					tagline: 'Pouvez-vous préciser ?',
					type: QuestionType.LongText,
					jump: () => "_e_a"
				}),

				new QuestionModel({
					id: "_e_a",
					required: true,
					helpTextShow: false,
					tagline: 'Souhaitez-vous que nous essayons de résoudre le problème afin que vous puissiez conserver le lien avec votre proche ?',
					type: QuestionType.MultipleChoice,
					options: [
						new ChoiceOption({
							label: 'Oui',
							value: 'CALL_ME_BACK'
						}),
						new ChoiceOption({
							label: 'Non',
							value: 'CANCEL'
						})
					],
					jump: () => "_submit"
				}),*/

				new QuestionModel({
					id: "_f",
					required: true,
					helpTextShow: false,
					tagline: `Pouvez-vous nous en dire un peu plus en quelques mots ? Votre retour nous est précieux. N’hésitez pas à nous partager votre expérience, surtout lorsque certains points sont difficiles à entendre. Chaque retour nous aide à nous améliorer pour mieux répondre aux attentes de nos futurs utilisateurs.`,
					type: QuestionType.LongText,
					jump: () => "_submit"
				}),

				new QuestionModel({
					id: "_g",
					required: true,
					helpTextShow: false,
					tagline: `Pouvez-vous nous en dire un peu plus en quelques mots ? Votre retour nous est précieux. N’hésitez pas à nous partager votre expérience, surtout lorsque certains points sont difficiles à entendre. Chaque retour nous aide à nous améliorer pour mieux répondre aux attentes de nos futurs utilisateurs.`,
					type: QuestionType.LongText,
					jump: () => "_submit"
				}),

			]
		};
  	},
	watch: {
		value(value){
			if(!value) {
				this.$refs.flowform.questionModels.forEach(question => {	
					question.answered = false;
					question.answer = this.multiple ? [] : null;
					question.other = null;
					question.resetOptions();
					question.options.forEach(option => {
						option.selected = false;
					});
				});
				this.$refs.flowform.activeQuestionIndex = 0;
			}
		}
	},
	async mounted() {
		this.reqError = null;
	},
	computed: {
		
	},
	methods: {

		getBase64File(path) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(path);
				reader.onload = () => resolve(reader.result);
				reader.onerror = reject;
			});
		},

		async submitCancellationRequest(questionList) {

			let reason = "";
			let comment = "";
			let files = [];

			for(let i=0; i<questionList.length; i++) {

				const question = questionList[i];

				if(question.type === "FlowFormMultipleChoiceType") {

					if(reason.length) {
						reason += ".";
					}
					reason += question.answer;

				} else if(question.type === "FlowFormLongTextType") {

					comment = question.answer;

				} else if(question.type === "FlowFormFileType") {
					files.push({
						name: question.answer[0].name,
						data: await this.getBase64File(question.answer[0]),
						type: question.answer[0].type
					})
				}
			}

			let response = await this.$axios.post(`${this.$config.server_url}/web/2.0/cancellationRequest`,{
				en_id: this.en_id,
				cr_reason: reason,
				cr_reason_comment: comment,
				cr_documents: files,
			});

			if(response.data.err) {
				this.reqError = response.err;
			} else {
				this.$emit("winCancellationRequestReload");
				this.$emit("winCancellationRequestClosed");
				//setTimeout(() => this.$emit("winCancellationRequestClosed"), 200);
			}	
		},

		closeModal() {
			this.$emit("winCancellationRequestClosed");
		},
	}
};
</script>

<style lang="css" scoped>
	@import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css';
	@import '../css/vue-flow-form.theme-emotivi.css';
</style>
